import Http from '@/api/http.js'

export default {
  index(params){
    return Http.get(`/pallets_histories`, {
      params
    });
  },
  create(pallets_history){
    return Http.post(`/pallets_histories`, {pallets_history: {...pallets_history}})
  },
  getEmployeeStock(params){
    return Http.get(`/pallets_histories/employee_stock`, {
      params
    });
  },
}